// import React, { useState } from 'react';
// import '../Styles/Contact.css';
// import agentImage from '../Resources/salaherobg.avif'; // Replace with your actual path
// import ph from '../Resources/phone-call.png'
// import mail from '../Resources/mail.png'
// import whatapp from '../Resources/whatsapp.png'

// export default function SalaContact() {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     message: '',
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Replace with your API endpoint
//     fetch('https://your-api-endpoint.com/contact', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(formData),
//     })
//       .then((res) => res.json())
//       .then((data) => alert('Message Sent Successfully'))
//       .catch((err) => alert('Error sending message'));
//   };

//   return (
//     <div className="sala-contact-container" id='contact'>
//       <div className="sala-contact-left">
//         <p className="sala-contact-subtitle">— CONTACT US</p>
//         <h2 className="sala-contact-title">Begin Your Journey Into Heritage</h2>
//         <p className="sala-contact-description">
//           Speak to our property advisors, or explore how you can be part of this timeless estate.</p>
//         <div className="sala-contact-agent-info">
//           <img src={agentImage} alt="Agent" className="sala-contact-agent-img" />
//           <div className="sala-contact-agent-details">
//             <p className="sala-contact-agent-phone"><span><img src={ph} className='Contact-social-media-icon'></img></span><a href="tel:9986800600" className='Contact-phone-link'>99868 00600</a></p>
//             {/* <p className="sala-contact-agent-phone"><span><img src={whatapp} className='Contact-social-media-icon'></img></span><a href='https://wa.me/919986800600' target='blank' className='Contact-phone-link'>99868 00600</a></p> */}
//             <a href="mailto:namaste@thesala.in" className="sala-contact-agent-email"><span><img src={mail} className='Contact-social-media-icon'></img></span> namaste@thesala.in</a>
//             {/* <div className="sala-contact-socials">
//               <button>🌐</button>
//               <button>📘</button>
//               <button>📸</button>
//             </div> */}
//           </div>
//         </div>
//       </div>


//       <form className="sala-contact-form" onSubmit={handleSubmit}>
//         <div className="sala-contact-input-row">
//           <input
//           className='sala-contact-name-input'
//             type="text"
//             name="name"
//             placeholder="Name*"
//             value={formData.name}
//             onChange={handleChange}
//             required
//           />
//           <input
//           className='sala-contact-name-input'
//             type="text"
//             name="phone"
//             placeholder="Phone number"
//             value={formData.phone}
//             onChange={handleChange}
//           />
//         </div>
//         <input
//         className='sala-contact-name-email'
//           type="email"
//           name="email"
//           placeholder="E-mail*"
//           value={formData.email}
//           onChange={handleChange}
//           required
//         />
//         <textarea
//           name="message"
//           placeholder="Your Message"
//           value={formData.message}
//           onChange={handleChange}
//         ></textarea>
//         <button type="submit" className="sala-contact-send-btn">SEND</button>
//       </form>
//     </div>
//   );
// }


import React, { useState } from 'react';
import '../Styles/Contact.css';
import agentImage from '../Resources/salaherobg.avif';
import ph from '../Resources/phone-call.png';
import mail from '../Resources/mail.png';
import whatapp from '../Resources/whatsapp.png';
import { trackLeadSubmit, trackHotline } from '../utils/Tracking';

export default function SalaContact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Get source from URL parameter 's' or default to "80"
    const searchParams = new URLSearchParams(window.location.search);
    const sourceValue = searchParams.get("s") || "80";

    // API payload in required format
    const payload = {
      name: formData.name,
      email: formData.email,
      number: formData.phone,
      "lead-message": formData.message,
      source: sourceValue,
      secret: "norg2021",
    };

    try {
      const res = await fetch("https://krushika.org/crm/endpoint.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.text();
      console.log("Response:", data);

      alert("Message Sent Successfully!");
      trackLeadSubmit();
    } catch (error) {
      console.error("Error:", error);
      alert("Error sending message");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="sala-contact-container" id='contact'>
      {/* (left content unchanged) */}
      <div className="sala-contact-left">
        <p className="sala-contact-subtitle">— CONTACT US</p>
        <h2 className="sala-contact-title">Begin Your Journey Into Heritage</h2>
        <p className="sala-contact-description">
          Speak to our property advisors, or explore how you can be part of this timeless estate.
        </p>

        <div className="sala-contact-agent-info">
          <img src={agentImage} alt="Agent" className="sala-contact-agent-img" />
          <div className="sala-contact-agent-details">
            <p className="sala-contact-agent-phone">
              <span><img src={ph} className='Contact-social-media-icon' alt="Phone" /></span>
              <a href="tel:9986800600" className='Contact-phone-link' onClick={() => trackHotline()}>99868 00600</a>
            </p>
            <a href="mailto:namaste@thesala.in" className="sala-contact-agent-email">
              <span><img src={mail} className='Contact-social-media-icon' alt="Email" /></span>
              namaste@thesala.in
            </a>
          </div>
        </div>
      </div>

      <form className="sala-contact-form" onSubmit={handleSubmit}>
        <div className="sala-contact-input-row">
          <input
            className='sala-contact-name-input'
            type="text"
            name="name"
            placeholder="Name*"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            className='sala-contact-name-input'
            type="text"
            name="phone"
            placeholder="Phone number"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
        <input
          className='sala-contact-name-email'
          type="email"
          name="email"
          placeholder="E-mail*"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        <button type="submit" className="sala-contact-send-btn" disabled={isLoading}>
          {isLoading ? "SENDING..." : "SEND"}
        </button>
      </form>
    </div>
  );
}
